<div class="col-span-full">
  <label for="cover-photo" class="block text-sm font-medium text-gray-900">Upload images</label>

  <div
    id="cover-photo"
    class="mt-2 flex justify-center rounded-lg border border-dashed border-gray-900/25 px-6 py-10 bg-white"
    [class.bg-gray-100]="isDragging"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)"
    >
    <div class="text-center">
      <svg class="mx-auto h-12 w-12 text-gray-300" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path
          fill-rule="evenodd"
          d="M1.5 6a2.25 2.25 0 012.25-2.25h16.5A2.25 2.25 0 0122.5 6v12a2.25 2.25 0 01-2.25 2.25H3.75A2.25 2.25 0 011.5 18V6zM3 16.06V18c0 .414.336.75.75.75h16.5A.75.75 0 0021 18v-1.94l-2.69-2.689a1.5 1.5 0 00-2.12 0l-.88.879.97.97a.75.75 0 11-1.06 1.06l-5.16-5.159a1.5 1.5 0 00-2.12 0L3 16.061zm10.125-7.81a1.125 1.125 0 112.25 0 1.125 1.125 0 01-2.25 0z"
          clip-rule="evenodd"
          />
        </svg>
        <div class="mt-4 flex text-sm text-gray-600">
          <label
            [for]="fileUploadId"
            class="relative cursor-pointer rounded-md bg-white font-semibold text-stone-600 hover:text-stone-500"
            >
            <span>Upload a file</span>
            <input
              [id]="fileUploadId"
              [name]="fileUploadId"
              type="file"
              [attr.multiple]="multiple ? '' : null"
              accept=".jpg, .jpeg, .png"
              class="sr-only"
              (change)="onFileSelected($event)"
              />
            </label>
            <p class="pl-1">or drag and drop</p>
          </div>
          <p class="text-xs text-gray-600">PNG, JPG up to {{ maxSizeMB }}MB</p>
        </div>
      </div>

      @if (previewImages.length > 0) {
        <div class="mt-4 relative">
          <div class="flex justify-center items-center relative">
            <button
              class="absolute left-0 top-1/2 transform -translate-y-1/2 px-2 py-1 text-gray-600 hover:text-black"
              (click)="prevSlide()"
              [disabled]="currentSlide === 0"
              >
              &#8592;
            </button>
            <div class="relative">
              <img
                [src]="previewImages[currentSlide]"
                alt="Preview"
                class="h-64 max-w-full object-contain rounded-lg border"
                />
                <button
                  mat-icon-button
                  color="warn"
                  class="absolute top-1 right-1 bg-white rounded-full shadow-sm text-red-600 hover:text-red-800"
                  (click)="removeImage(currentSlide)"
                  aria-label="Remove image"
                  >
                  <mat-icon>close</mat-icon>
                </button>
              </div>
              <button
                class="absolute right-0 top-1/2 transform -translate-y-1/2 px-2 py-1 text-gray-600 hover:text-black"
                (click)="nextSlide()"
                [disabled]="currentSlide === previewImages.length - 1"
                >
                &#8594;
              </button>
            </div>
            <div class="text-center mt-2 text-sm text-gray-600">Image {{ currentSlide + 1 }} of {{ previewImages.length }}</div>
          </div>
        }
      </div>
